/** @format */

import React from 'react';
import GridItem from '../../../../components/Grid/GridItem';
import CustomMultiSelect from '../../../../components/Form/CustomMultiSelect';

interface MnpEventFormProps {
    mnpTypes: any;
    mnpEventType: Array<string>;
    handleChangeMultiple: (event: any) => void;
}

const MnpEventForm = (props: MnpEventFormProps): React.ReactElement => {
    return (
        <GridItem xs={4}>
            <CustomMultiSelect
                callback={props.handleChangeMultiple}
                value={props.mnpEventType}
                name={'mnpEventType'}
                isElementsFromApi={true}
                elements={props.mnpTypes}
                elementItemValue={'value'}
                elementItemName={'name'}
                label={'specialized_report:h.mnp_event_type'}
                showSelectAllButton
            />
        </GridItem>
    );
};

export default MnpEventForm;
